const FUEL_GRADES = {
  hfo: 'HFO',
  lfo: 'LFO',
  mgo: 'MGO',
  mdo: 'MDO',
  ulsfo2020: 'ULSFO2020',
  ulslfo2020: 'ULSLFO2020',
  ulsmdo2020: 'ULSMDO2020',
  ulsmgo2020: 'ULSMGO2020',
  vlsfo2020: 'VLSFO2020',
  vlslfo2020: 'VLSLFO2020',
  lpgp: 'LPGP',
  lpgb: 'LPGB',
  lng: 'LNG',
  methanol: 'Methanol',
  ethanol: 'Ethanol',
  hvo: 'HVO',
  fame: 'FAME',
  biodiesel: 'Biodiesel',
  bio_lng: 'Bio-LNG',
  other: 'Other',
};

const LNG_FUEL_GRADES = ['lng', 'bio_lng'];
const BANNED_FUEL_GRADES = ['B10LFO', 'B10MGO', 'BIOLFO', 'BIOMGO'];

export { FUEL_GRADES, LNG_FUEL_GRADES, BANNED_FUEL_GRADES };
